// let baseUrl = 'http://information-education-server-qa.qalb.jsxfedu.net'
// let baseUrl = 'http://10.4.180.142:9201'
let baseUrl = process.env.VUE_APP_API_URL || ''
let publicUrl = {
  // 公共
  getBatchFileUrl: baseUrl + '/oss/post-batch-file-url', // 批量获取文件下载地址
  gradeVolumes: baseUrl + '/textbook/grade-volumes', // 课程编辑-年级册次

  // 首页
  textbookList: baseUrl + '/textbook/list', // 首页-教材列表

  // 登录
  login: baseUrl + '/login', // 登录
  logout: baseUrl + '/logout', // 退出登录
  currentUser: baseUrl + '/current-user', // 当前登录用户信息

  // 修改登录密码
  updatePassword: baseUrl + '/update-password', // 根据原密码修改登录密码
  updateHead: baseUrl + '/update-head', // 修改头像

  // 班级管理 -【教师端】
  classGroupList: baseUrl + '/teacher-class/group', // 组-班级小组【教师】
  classStudentsList: baseUrl + '/teacher-class/students', // 学生-班级学生列表【教师】
  resetStudentPwd: baseUrl + '/teacher-class/reset-student-pwd', // 学生-重置密码【教师】
  saveGroup: baseUrl + '/teacher-class/save-group', // 组-新增或编辑小组【教师】
  delGroup: baseUrl + '/teacher-class/del-group', // 组-删除组【教师】
  randomGroup: baseUrl + '/teacher-class/group/random-assigned', // 组-随机分组 【教师】
  saveGroupRef: baseUrl + '/teacher-class/save-group-ref', // 组-保存组内学生信息【教师】

  // 班级管理 -【学生】
  myClass: baseUrl + '/student-class/my-class', // 班级-我的班级信息【学生】
  joinGroup: baseUrl + '/student-class/join-group', // 组-加入小组【学生】
  updateStudent: baseUrl + '/teacher-class/update-student', // 学生-编辑学生【教师】
  editPassword: baseUrl + '/account/change-password', // 修改密码
  studentImport: baseUrl + '/account/student-import', // 学生导入

  // 教材相关-【教师】

  associateClass: baseUrl + '/textbook/associate-class', // 关联班级
  addChapter: baseUrl + '/chapter/add-update', // 添加目录
  delChapter: baseUrl + '/chapter/del', // 删除目录
  addPublicCourse: baseUrl + '/textbook/add-public', // 创建标准课程
  addMyCourse: baseUrl + '/textbook/add', // 创建自制课程

  myCourseList: baseUrl + '/textbook/self', // 我的课程
  schoolOpenCourse: baseUrl + '/textbook/school', // 校内公开课程(所有角色)
  studentCourseList: baseUrl + '/textbook/student', // 学生课程列表


  publicCourseList: baseUrl + '/textbook/public-up', // 标准课程(校管)
  publicCourseListEdit: baseUrl + '/textbook/public-edit', // 标准课程(编辑)
  publicCourseListCheckEditLeader: baseUrl + '/textbook/public-check-final', // 标准课程(审核负责人)
  publicCourseListCheckEdit: baseUrl + '/textbook/public-check', // 标准课程(编辑)

  videoCourseList:baseUrl + '/course/video/video-list', //视频课程列表
  videoCOurseDetail:baseUrl + '/course/video/video-detail',//视频详情



  courseList: baseUrl + '/textbook/course-list', // 课程列表(公开、校本、我的)
  courseCatalog: baseUrl + '/textbook/course-catalog', // 课程详情-课程目录
  teachingClasses: baseUrl + '/textbook/teaching-classes', // 课程详情-授课班级列表
  finishCourse: baseUrl + '/textbook/finish-course', // 课程详情-已完成课时
  projectDetails: baseUrl + '/textbook/project-details', // 课程详情-项目详情
  projectWorksDetails: baseUrl + '/textbook/project-works-details', // 课程详情-项目作品详情
  textbookInfo: baseUrl + '/textbook/info', // 图书详情
  bookCopy: baseUrl + '/textbook/book-copy', // 复制课程
  bookDelete: baseUrl + '/textbook/delete', // 我的课程-删除
  bookUpAndDown: baseUrl + '/textbook/up-and-down', // 我的课程-上下架
  projectWorks: baseUrl + '/task/project-works', // 项目作品提交记录
  projectWorksUndo: baseUrl + '/task/project-works-undo', // 项目作品未参与者
  projectWorksUpdate: baseUrl + '/textbook/project-works-upd', // 课程编辑-项目作品修改
  projectDetailsUpdate: baseUrl + '/textbook/project-details-upd', // 课程编辑-项目详情修改
  projectTasks: baseUrl + '/textbook/project-tasks', // 课程详情-项目任务列表
  taskDetails1: baseUrl + '/textbook/task-details', // 课程编辑-任务详情
  taskDetailsUpdate: baseUrl + '/textbook/task-details-upd', // 课程编辑-任务详情修改
  taskDetails: baseUrl + '/task/task-details', // 课程详情-任务详情
  groupRecord: baseUrl + '/task/group-record', // 教师 - 组内聊天记录
  projectUnits: baseUrl + '/textbook/project-units', // 课程详情-项目单元列表
  worksReview: baseUrl + '/task/works-review', // 作品-评论(课堂作品/项目作品)
  worksEvaluate: baseUrl + '/task/works-evaluate', // 作品-教师评价(课堂作品/项目作品)
  submitWorksReview: baseUrl + '/student-job/submit-review', // 评论作业/作品
  deleteWorksReview: baseUrl + '/student-job/delete-review', // 作业/作品评论删除
  submitProjectWork: baseUrl + '/student-job/submit-project', // 提交项目作品作业
  classroomBegin: baseUrl + '/task/classroom-begin', // 教师上课
  classroomEnd: baseUrl + '/task/classroom-end', // 教师下课
  modelDetails: baseUrl + '/task/model-details', // 课程详情-模块详情
  classroomTestList: baseUrl + '/task/classroom-test-list', // 课堂小测-题目列表
  bookBindClass: baseUrl + '/client-class/book-bind', // 图书绑定班级
  classroomQuestionList: baseUrl + '/task/classroom-question-list', // 课堂问卷-题目列表
  classroomQuestionUndo: baseUrl + '/task/classroom-question-undo', // 课堂问卷未参与人
  classroomWorks: baseUrl + '/task/classroom-works', // 课堂作业
  classroomWorksUndo: baseUrl + '/task/classroom-works-undo', // 课堂作业未参与者
  worksRevoke: baseUrl + '/task/works-revoke', // 课堂作业作品撤回
  groupChatRecords: baseUrl + '/group-chat/group-chat-records', // 学生 - 组内聊天
  groupChatUndo: baseUrl + '/task/group-chat-undo', // 组内聊天未参与者
  groupChatDelete: baseUrl + '/group-chat/delete', // 组内聊天记录删除
  submitClasswork: baseUrl + '/student-job/submit-classwork', // 提交课堂作业
  addTask: baseUrl + '/textbook/project-task-add', // 添加任务
  submitKtxc: baseUrl + '/student-quiz/submit', // 提交课堂小测
  submitKtwj: baseUrl + '/student-questionnaire/submit', // 提交课堂问卷
  modelBegin: baseUrl + '/task/model-begin', // 模块开关开启
  modelEnd: baseUrl + '/task/model-end', // 模块开关关闭

  // 主题讨论-【学生】
  topicRecords: baseUrl + '/task/topic-records', // 主题讨论回复
  topicUndo: baseUrl + '/task/topic-undo', // 主题讨论未参与者
  topicSave: baseUrl + '/student-topic/save', // 保存主题讨论
  groupChatSave: baseUrl + '/group-chat/submit', // 组内聊天提交

  // 评价方案-【教师】
  projectEvaluate: baseUrl + '/evaluate/project-evaluate', // 评价-项目评价查看
  projectEvaluateUpdate: baseUrl + '/evaluate/project-evaluate-upd', // 评价-项目评价修改
  taskEvaluate: baseUrl + '/evaluate/task-evaluate', // 评价-任务评价查看
  taskEvaluateUpdate: baseUrl + '/evaluate/task-evaluate-upd', // 评价-任务评价修改
  studentProjectEvaluate: baseUrl + '/student-evaluate/project-evaluate', // 评价-项目评价查看
  // 我的教学
  famousStudyList: baseUrl + '/famous-teacher/study-list', // 我的教学/我的学习


  // 审核
  commitReview: baseUrl + '/textbook/commit-review', // 提交复审
  commitFinal: baseUrl + '/textbook/commit-final', // 提交终审
  commitRefuse: baseUrl + '/textbook/refuse', // 驳回
  commitFinalPass: baseUrl + '/textbook/final-pass', // 终审通过
  courseUpOrDown: baseUrl + '/textbook/up-and-down', // 上架下架


  // 新增班级
  addClass: baseUrl + '/client-class/add-update', // 新增班级
  addClassList: baseUrl + '/client-class/page', // 班级列表
  classDel: baseUrl + '/client-class/del', // 删除班级

  // 新增教師
  notCorrelationClass: baseUrl + '/client-class/not-associated', // 未关联班级
  addTeacher: baseUrl + '/account/teacher-add-upd', // 教师新增/修改(校管)
  teacherList: baseUrl + '/account/page-teacher', // 教师列表
  teacherDel: baseUrl + '/account/teacher-del', // 教师账号删除
  teacherDisabled: baseUrl + '/account/teacher-disabled', // 教师账号启/禁用

  // 新增学生
  addStudent: baseUrl + '/account/student-add-upd', // 新增学生
  studentList: baseUrl + '/account/page-student', // 学生列表
  addStudentClassList: baseUrl + '/client-class/grade-group', // 年级班级列表
  studentDisabled: baseUrl + '/account/student-disabled', // 学生账号启/禁用
  studentDel: baseUrl + '/account/student-del', // 学生账号删除/禁用 

  // 作业
  submitStudentWork: baseUrl + '/quiz/submit', // 提交作业 
  analysisFlag: baseUrl + '/task/analysis-change', // 答案开放标识变更 
  submitEvaluate: baseUrl + '/task/subjective-evaluate', // 主观题评价 

  // 评价
  taskEvaluateList: baseUrl + '/task/evaluate-list', // 评价列表 
  evaluateSubmit: baseUrl + '/evaluate/submit', // 提交评价 

  checkInfo: baseUrl + '/textbook/check-info', // 获取审核建议 
  applyOpen: baseUrl + '/textbook/apply', // 申请公开课程 
  openOrNot: baseUrl + '/textbook/open', // 校内公开课程公开(校管) 
  // 消息
  teaMessageList: baseUrl + '/message/tea-list', // 教师动态消息列表
  stuMessageList: baseUrl + '/message/stu-list', // 学生动态消息列表
  readMessageOne: baseUrl + '/message/read-one', // 单个消息读取
  readMessageAll: baseUrl + '/message/read-all', // 动态消息全部读取

  //视频课程
    videoList: baseUrl + "/course/video/video-list", //视频分页列表
    getVideoDetail: baseUrl + "/course/video/video-detail", //视频详情
    getPlayAuth :baseUrl + '/course/video/play-auth', //获取播放凭证

  //图书信息
  bookList: baseUrl + "/book/book-list", //视频分页列表
  getFileKey:baseUrl + "/oss/get-file-url", //获取文件url

  //教学资源
  teachResourceList :baseUrl +'/teach/list',//资源列表
  teachResourceDetail :baseUrl +'/teach/getResourceDetail',//资源详情
  updateVistis:baseUrl+"/teach/updateVisits",

  //帮助问题列表
  helpModuleList:baseUrl +"/help/module/list"


}

export default publicUrl
